$(window).on('load', function() {

	let address = [
		'[name="address[route]"]',
		'[name="address[locality]"]',
		'[name="address[postal_code]"]',
		'[name="address[administrative_area_level_2]"]',
		'[name="address[country]"]'
	];

	let address_hidden = [
		'[name="address[value]"]',
		'[name="address[lat]"]',
		'[name="address[lng]"]'
	];

	let classInput = [
		'block',
		'border-gray-300',
		'focus:border-indigo-800',
		'focus:ring',
		'focus:ring-indigo-800',
		'focus:ring-opacity-25',
		'hover:border-indigo-800',
		'form-checkbox',
		'w-5',
		'h-5',
		'text-indigo-800',
		'rounded-md'
	];

	let classLabel = [
		'block',
		'tracking-wide',
		'text-grey-600',
		'select-none'
	];

	let classContainer = [
		'flex',
		'space-x-2',
		'items-center',
		'border-b',
		'pb-4',
		'w-full',
		'mt-4'
	];

	let label = 'Je ne parviens pas à trouver mon adresse';

	let template = '<div class="'+ classContainer.join(' ') +'">'
	               + '<input type="checkbox" id="nonExistentAddress" class="'+ classInput.join(' ') +'">'
	               + '<label class="'+ classLabel.join(' ') +'">'+ label +'</label>'
	               + '</div>';

	let listDepartmentToModify = {
		'Île-de-France': 'Paris'
	};



	function addressContainer(i = 0) {

		setTimeout(function() {

			let addressContainer_e = $('.address-container');
			let address_e = '#address';

			if( addressContainer_e.find(address_e).length && !$('#nonExistentAddress').length ) {

				addressContainer_e.find(address_e).addClass('flex-wrap').append(template);

				addressContainer_e.find(address.join(', ')).attr({
					'wire:ignore.self': '',
					'readonly': 'readonly'
				}).addClass('read-only').on('change', function() {

					addressContainer_e.parents('form').find('button[type="submit"]').removeAttr('disabled');
				});

				addressContainer_e.find('#nonExistentAddress').on('change', function() {

					if( $(this).prop('checked') ) {

						addressContainer_e.find(address.join(', ')).removeAttr('readonly').removeClass('read-only');
						addressContainer_e.find(address_hidden.join(', ')).val('');

					} else {

						addressContainer_e.find(address.join(', ')).attr('readonly', 'readonly').addClass('read-only');
					}

				});

				addressContainer_e.find('input.mapboxgl-ctrl-geocoder--input').on('change', function() {
					setTimeout(function() {
						$.each(listDepartmentToModify, function(k, v) {

							if( $(address[3]).val() === k ) {

								addressContainer_e.find(address[3]).val(v);
								addressContainer_e[0]._x_dataStack[0].address.administrative_area_level_2 = v;
								return false;
							}
						});
					}, 500);
				});
			}

		}, i);
	}



	addressContainer();

	if( $('[x-show="nextStepIsAvailable == true"]').length ) {

		$('html').on('click', '[x-show="nextStepIsAvailable == true"]', function() {
			addressContainer(1600);
		});
	}

});
